import React from "react";
import { PageLayout } from "../common/layout";
import { ComingSoon } from "../common/components";

// Página custom. Llenala en develop; el merge base→develop preserva tus cambios.
export const CuesheetsPage = () => {
  return (
    <PageLayout>
      <ComingSoon
        title="Cue Sheets"
        description="Planillas de uso musical en producciones audiovisuales, detallando cada obra utilizada."
      />
    </PageLayout>
  );
};
